import React from 'react';
import StyledRadio from '@components/radio/styled.tsx';
import type { RadioGroupProps, RadioProps } from 'antd';
import { Radio } from 'antd';

export const BaseRadio: React.FC<RadioProps> = (props) => <StyledRadio {...props} />;

export const BaseRadioGroup: React.FC<RadioGroupProps> = (props) => <Radio.Group {...props} />;
